import {
    Model
} from '@vuex-orm/core'

export default class Media extends Model {
    static entity = 'medias'

    static fields() {
        return {
            id: this.attr(null),
            filename: this.attr(null),
            url: this.attr(null),
            note_id: this.attr(null),
            created_user_id: this.attr(1)
        }
    }


}